module.exports = __webpack_public_path__ + "img/detail8.e3f40be2.png";